var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.84981 10.2541C3.08118 7.3873 4.78207 4.44023 7.64884 3.6716C10.5156 2.90297 13.4627 4.60385 14.2313 7.47063C15 10.3374 13.2991 13.2845 10.4323 14.0531C7.56552 14.8217 4.61844 13.1209 3.84981 10.2541ZM7.13084 1.7396C3.19705 2.79431 0.8631 6.83829 1.91781 10.7721C2.97252 14.7059 7.0165 17.0398 10.9503 15.9851C12.7542 15.5015 14.2216 14.3892 15.1802 12.9473L18.7119 14.9856C19.1902 15.2617 19.8019 15.0977 20.078 14.6193C20.3541 14.1409 20.1901 13.5293 19.7117 13.2532L16.0545 11.1424C16.4822 9.83087 16.5472 8.38445 16.1633 6.95263C15.1086 3.01884 11.0646 0.684885 7.13084 1.7396Z","fill":"currentColor"}));
}

Search.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = Search;

Search.default = Search;
